import React from "react";
import Image from "next/image";
import Section from "@/components/ui/section";
export default function AboutPci() {
  return (
    <Section className="w-full bg-[#181733]">
      <div className="w-full flex flex-col items-start">
        <div className="mb-5 lg:mb-6">
          <Image
            src="/images/footer-logo.svg"
            alt="People's Courage International Logo"
            width={312}
            height={85}
            className="w-[220px] sm:w-[280px] lg:w-[260px] h-auto"
          />
        </div>
        <p className="text-white font-normal leading-[1.5] text-sm md:text-base max-w-full lg:max-w-[62%]">
          PCI empowers community-led organizations across South and Southeast
          Asia. PCI promotes initiatives that work deeply – and at scale – on
          the ground and leverage this to change systems.
        </p>
      </div>
    </Section>
  );
}
